/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [{
  action: 'updateCustomerRunnerContractDiscountsByRootId',
  message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_CONTRACT_DISCOUNTS_BY_ROOT_ID,
  method: 'PATCH',
  path: '/customer/:customerId/runner-contract-discounts/:rootId',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_CONTRACT_DISCOUNT,
  requestSchema: requestSchemas.customerRunnerContractDiscounts.updateCustomerRunnerContractDiscountsByRootId,
}];
